export const catalogCollections = [
  {
    "slug": "dolomite",
    "name": "Dolomite",
    "category": "porselen",
    "finish": "Mat",
    "color": "Bone",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.85 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Banyo",
      "Duvar"
    ],
    "image": "/catalog/dolomite-hero.jpg",
    "hero": "/catalog/dolomite-hero.jpg",
    "tile": "/catalog/dolomite-tile.jpg",
    "gallery": [
      "/catalog/dolomite-hero.jpg",
      "/catalog/dolomite-tile.jpg"
    ],
    "description": "Beyaz dolomit yüzeyin dingin karakterini modern banyo mimarisine taşıyan bir koleksiyon. Damar dokusu doğal aydınlatmada hafif bir opaklık kazanır.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.85 cm",
      "Yüzey": "Mat",
      "Renk": "Bone",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "vesna",
    "name": "Vesna",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Bone",
    "sizes": [
      "60x120 cm",
      "80x160 cm",
      "120x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Salon",
      "Geniş Format"
    ],
    "image": "/catalog/vesna-hero.jpg",
    "hero": "/catalog/vesna-hero.jpg",
    "tile": "/catalog/vesna-tile.jpg",
    "gallery": [
      "/catalog/vesna-hero.jpg",
      "/catalog/vesna-tile.jpg"
    ],
    "description": "Doğal kireçtaşı esintili sıcak bej tonlarını geniş formatlı dilimlerle sunan zemin koleksiyonu; aydınlık lobiler için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm / 120x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Bone",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "riva",
    "name": "Riva",
    "category": "dis-mekan",
    "finish": "Mat",
    "color": "Grafit",
    "sizes": [
      "60x60 cm",
      "60x120 cm"
    ],
    "thickness": "2 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Gri",
      "Teras",
      "Bahçe"
    ],
    "image": "/catalog/riva-hero.jpg",
    "hero": "/catalog/riva-hero.jpg",
    "tile": "/catalog/riva-tile.jpg",
    "gallery": [
      "/catalog/riva-hero.jpg",
      "/catalog/riva-tile.jpg"
    ],
    "description": "Naif tasarım detayları ve mat formuyla Riva; modern mimarinin doğal formda bırakılmış yapı malzemesi estetiğini yaşam alanlarına taşır.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x60 cm / 60x120 cm",
      "Kalınlık": "2 cm",
      "Yüzey": "Mat",
      "Renk": "Grafit",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "sava",
    "name": "Sava",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Onyx White",
    "sizes": [
      "30x90 cm",
      "60x120 cm",
      "80x160 cm",
      "120x120 cm"
    ],
    "thickness": "1.1 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Onyx",
      "Salon",
      "Duvar"
    ],
    "image": "/catalog/sava-hero.jpg",
    "hero": "/catalog/sava-hero.jpg",
    "tile": "/catalog/sava-tile.jpg",
    "gallery": [
      "/catalog/sava-hero.jpg",
      "/catalog/sava-tile.jpg"
    ],
    "description": "Bulutumsu damarlarıyla oniks esintili bir salon koleksiyonu. Parlak yüzeyi doğal ışığı yansıtarak mekâna derinlik katar.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "30x90 cm / 60x120 cm / 80x160 cm / 120x120 cm",
      "Kalınlık": "1.1 cm",
      "Yüzey": "Parlak",
      "Renk": "Onyx White",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "calacatta",
    "name": "Calacatta",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm",
      "120x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Klasik",
      "Salon"
    ],
    "image": "/catalog/calacatta-hero.jpg",
    "hero": "/catalog/calacatta-hero.jpg",
    "tile": "/catalog/calacatta-tile.jpg",
    "gallery": [
      "/catalog/calacatta-hero.jpg",
      "/catalog/calacatta-tile.jpg"
    ],
    "description": "Beyaz zemin üzerine ince damar detaylarıyla zarif bir porselen koleksiyonu; banyo ve salon zeminleri için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 120x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "aden",
    "name": "Aden",
    "category": "seramik",
    "finish": "Mat",
    "color": "Fume",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Gri",
      "Duvar",
      "Modern"
    ],
    "image": "/catalog/aden-hero.jpg",
    "hero": "/catalog/aden-hero.jpg",
    "tile": "/catalog/aden-tile.jpg",
    "gallery": [
      "/catalog/aden-hero.jpg",
      "/catalog/aden-tile.jpg"
    ],
    "description": "İnce çizgi hareketleriyle sakin bir modernizmi yakalayan yüzey — endüstriyel şıklığı iç mekâna taşır.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Fume",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "alba",
    "name": "Alba",
    "category": "porselen",
    "finish": "Mat",
    "color": "Beyaz",
    "sizes": [
      "60x60 cm",
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Salon"
    ],
    "image": "/catalog/alba-hero.jpg",
    "hero": "/catalog/alba-hero.jpg",
    "tile": "/catalog/alba-tile.jpg",
    "gallery": [
      "/catalog/alba-hero.jpg",
      "/catalog/alba-tile.jpg"
    ],
    "description": "Sınırların ötesine geçen berrak beyaz. Alba, geniş salonlarda ışığı yumuşatan dingin bir zemin dili.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x60 cm / 60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },

  {
    "slug": "amazonit",
    "name": "Amazonit",
    "category": "banyo",
    "finish": "Parlak",
    "color": "Yeşil",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Yeşil",
      "Butik",
      "Duvar"
    ],
    "image": "/catalog/amazonit-hero.jpg",
    "hero": "/catalog/amazonit-hero.jpg",
    "tile": "/catalog/amazonit-tile.jpg",
    "gallery": [
      "/catalog/amazonit-hero.jpg",
      "/catalog/amazonit-tile.jpg"
    ],
    "description": "Amazon taşının derin yeşilini duvarınıza taşıyan sıra dışı koleksiyon. Butik konseptler için ideal.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Yeşil",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "aspen",
    "name": "Aspen",
    "category": "porselen",
    "finish": "Mat",
    "color": "Karlı Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Minimal"
    ],
    "image": "/catalog/aspen-hero.jpg",
    "hero": "/catalog/aspen-hero.jpg",
    "tile": "/catalog/aspen-tile.jpg",
    "gallery": [
      "/catalog/aspen-hero.jpg",
      "/catalog/aspen-tile.jpg"
    ],
    "description": "Karlı dağ dokusundan ilham alan yumuşak, mat bir beyaz. Skandinav estetiğine uyumlu.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Karlı Beyaz",
      "V Sınıfı": "V3"
    }
  },


  {
    "slug": "canyon",
    "name": "Canyon",
    "category": "porselen",
    "finish": "Yapısal",
    "color": "Terracotta",
    "sizes": [
      "60x120 cm",
      "80x160 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Terracotta",
      "Salon"
    ],
    "image": "/catalog/canyon-hero.jpg",
    "hero": "/catalog/canyon-hero.jpg",
    "tile": "/catalog/canyon-tile.jpg",
    "gallery": [
      "/catalog/canyon-hero.jpg",
      "/catalog/canyon-tile.jpg"
    ],
    "description": "Kayalık kanyon dokularının rölyefli yorumu; doğal bir sıcaklık ve derinlik.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yapısal",
      "Renk": "Terracotta",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "cement",
    "name": "Cement",
    "category": "seramik",
    "finish": "Mat",
    "color": "Beton Gri",
    "sizes": [
      "60x60 cm",
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Gri",
      "Loft",
      "Ofis"
    ],
    "image": "/catalog/cement-hero.jpg",
    "hero": "/catalog/cement-hero.jpg",
    "tile": "/catalog/cement-tile.jpg",
    "gallery": [
      "/catalog/cement-hero.jpg",
      "/catalog/cement-tile.jpg"
    ],
    "description": "Endüstriyel beton dokusunu premium bir yüzeye dönüştüren koleksiyon. Modern ofisler ve loftlar için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x60 cm / 60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Beton Gri",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "dante",
    "name": "Dante",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Salon"
    ],
    "image": "/catalog/dante-hero.jpg",
    "hero": "/catalog/dante-hero.jpg",
    "tile": "/catalog/dante-tile.jpg",
    "gallery": [
      "/catalog/dante-hero.jpg",
      "/catalog/dante-tile.jpg"
    ],
    "description": "Büyük formatta parlak beyaz yüzey — salon ve lobi alanları için güçlü bir estetik.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "elegant",
    "name": "Elegant",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Bej",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Klasik"
    ],
    "image": "/catalog/elegant-hero.jpg",
    "hero": "/catalog/elegant-hero.jpg",
    "tile": "/catalog/elegant-tile.jpg",
    "gallery": [
      "/catalog/elegant-hero.jpg",
      "/catalog/elegant-tile.jpg"
    ],
    "description": "Zarif bej tonlarında parlak bir porselen; klasik mekânlara sakin bir lüks katar.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "elit",
    "name": "Elit",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Butik"
    ],
    "image": "/catalog/elit-hero.jpg",
    "hero": "/catalog/elit-hero.jpg",
    "tile": "/catalog/elit-tile.jpg",
    "gallery": [
      "/catalog/elit-hero.jpg",
      "/catalog/elit-tile.jpg"
    ],
    "description": "Beyaz zemin üzerine ince damar detayları — butik mekânlara aydınlık bir karakter.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "ella",
    "name": "Ella",
    "category": "porselen",
    "finish": "Mat",
    "color": "Nude",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Nude",
      "Yatak Odası"
    ],
    "image": "/catalog/ella-hero.jpg",
    "hero": "/catalog/ella-hero.jpg",
    "tile": "/catalog/ella-tile.jpg",
    "gallery": [
      "/catalog/ella-hero.jpg",
      "/catalog/ella-tile.jpg"
    ],
    "description": "Sıcak nude tonlarıyla huzurlu bir yatak odası atmosferi.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Nude",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "eterna",
    "name": "Eterna",
    "category": "mutfak",
    "finish": "Yarı Parlak",
    "color": "Bej",
    "sizes": [
      "60x120 cm",
      "80x160 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Rezidans"
    ],
    "image": "/catalog/eterna-hero.jpg",
    "hero": "/catalog/eterna-hero.jpg",
    "tile": "/catalog/eterna-tile.jpg",
    "gallery": [
      "/catalog/eterna-hero.jpg",
      "/catalog/eterna-tile.jpg"
    ],
    "description": "Zamansız bej tonlarında sırlı porselen — uzun ömürlü ve kolay bakım.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "focus",
    "name": "Focus",
    "category": "seramik",
    "finish": "Mat",
    "color": "Antrasit",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Antrasit",
      "Ofis",
      "Modern"
    ],
    "image": "/catalog/focus-hero.jpg",
    "hero": "/catalog/focus-hero.jpg",
    "tile": "/catalog/focus-tile.jpg",
    "gallery": [
      "/catalog/focus-hero.jpg",
      "/catalog/focus-tile.jpg"
    ],
    "description": "Odaklanmayı destekleyen sakin antrasit; modern ofis mimarisinin dili.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Antrasit",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "granada",
    "name": "Granada",
    "category": "mutfak",
    "finish": "Parlak",
    "color": "Krem",
    "sizes": [
      "60x120 cm",
      "80x160 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Krem",
      "Salon"
    ],
    "image": "/catalog/granada-hero.jpg",
    "hero": "/catalog/granada-hero.jpg",
    "tile": "/catalog/granada-tile.jpg",
    "gallery": [
      "/catalog/granada-hero.jpg",
      "/catalog/granada-tile.jpg"
    ],
    "description": "Endülüs sarayları esintili sıcak krem; salon zeminlerinde geniş bir ferahlık.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Krem",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "gusto",
    "name": "Gusto",
    "category": "mutfak",
    "finish": "Yarı Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Mutfak"
    ],
    "image": "/catalog/gusto-hero.jpg",
    "hero": "/catalog/gusto-hero.jpg",
    "tile": "/catalog/gusto-tile.jpg",
    "gallery": [
      "/catalog/gusto-hero.jpg",
      "/catalog/gusto-tile.jpg"
    ],
    "description": "Modern mutfaklara zamansız bir zemin — pratik, dayanıklı, estetik.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },

  {
    "slug": "himalaya",
    "name": "Himalaya",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Duman",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Duman",
      "Butik"
    ],
    "image": "/catalog/himalaya-hero.jpg",
    "hero": "/catalog/himalaya-hero.jpg",
    "tile": "/catalog/himalaya-tile.jpg",
    "gallery": [
      "/catalog/himalaya-hero.jpg",
      "/catalog/himalaya-tile.jpg"
    ],
    "description": "Karlı dağların derinliğinden bir yorum — sessiz, güçlü, karakterli.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Duman",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "kartepe",
    "name": "Kartepe",
    "category": "dis-mekan",
    "finish": "Mat",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Minimal"
    ],
    "image": "/catalog/kartepe-hero.jpg",
    "hero": "/catalog/kartepe-hero.jpg",
    "tile": "/catalog/kartepe-tile.jpg",
    "gallery": [
      "/catalog/kartepe-hero.jpg",
      "/catalog/kartepe-tile.jpg"
    ],
    "description": "Karlı Kartepe'nin dinginliği — mat, saf, yalın.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "kosta",
    "name": "Kosta",
    "category": "seramik",
    "finish": "Mat",
    "color": "Doğal Taş",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Rustik"
    ],
    "image": "/catalog/kosta-hero.jpg",
    "hero": "/catalog/kosta-hero.jpg",
    "tile": "/catalog/kosta-tile.jpg",
    "gallery": [
      "/catalog/kosta-hero.jpg",
      "/catalog/kosta-tile.jpg"
    ],
    "description": "Ege sahilinin doğal taş yüzeyi; rustik ve sıcak.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Doğal Taş",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "kristal",
    "name": "Kristal",
    "category": "banyo",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Butik"
    ],
    "image": "/catalog/kristal-hero.jpg",
    "hero": "/catalog/kristal-hero.jpg",
    "tile": "/catalog/kristal-tile.jpg",
    "gallery": [
      "/catalog/kristal-hero.jpg",
      "/catalog/kristal-tile.jpg"
    ],
    "description": "Kristal berraklığında beyaz — ışığı yansıtan zamansız bir yüzey.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "kuvars",
    "name": "Kuvars",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Gri",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Gri",
      "Modern"
    ],
    "image": "/catalog/kuvars-hero.jpg",
    "hero": "/catalog/kuvars-hero.jpg",
    "tile": "/catalog/kuvars-tile.jpg",
    "gallery": [
      "/catalog/kuvars-hero.jpg",
      "/catalog/kuvars-tile.jpg"
    ],
    "description": "Kuvars taşının mineral yansımaları; modern mekânlar için karakterli.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Gri",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "levante",
    "name": "Levante",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x60 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Klasik"
    ],
    "image": "/catalog/levante-hero.jpg",
    "hero": "/catalog/levante-hero.jpg",
    "tile": "/catalog/levante-tile.jpg",
    "gallery": [
      "/catalog/levante-hero.jpg",
      "/catalog/levante-tile.jpg"
    ],
    "description": "Beyaz zemin üzerine zarif damar detaylarıyla çağdaş bir porselen yorumu.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x60 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "lotus",
    "name": "Lotus",
    "category": "banyo",
    "finish": "Mat",
    "color": "Krem",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Krem",
      "Spa"
    ],
    "image": "/catalog/lotus-hero.jpg",
    "hero": "/catalog/lotus-hero.jpg",
    "tile": "/catalog/lotus-tile.jpg",
    "gallery": [
      "/catalog/lotus-hero.jpg",
      "/catalog/lotus-tile.jpg"
    ],
    "description": "Sakin krem tonlarıyla spa ve wellness alanları için ideal.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Krem",
      "V Sınıfı": "V3"
    }
  },

  {
    "slug": "napoli",
    "name": "Napoli",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Salon"
    ],
    "image": "/catalog/napoli-hero.jpg",
    "hero": "/catalog/napoli-hero.jpg",
    "tile": "/catalog/napoli-tile.jpg",
    "gallery": [
      "/catalog/napoli-hero.jpg",
      "/catalog/napoli-tile.jpg"
    ],
    "description": "Napoli'nin barok mimari zenginliğini modern bir yüzeye taşıyan koleksiyon.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "nemrut",
    "name": "Nemrut",
    "category": "granit",
    "finish": "Mat",
    "color": "Antrasit",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Antrasit",
      "Butik"
    ],
    "image": "/catalog/nemrut-hero.jpg",
    "hero": "/catalog/nemrut-hero.jpg",
    "tile": "/catalog/nemrut-tile.jpg",
    "gallery": [
      "/catalog/nemrut-hero.jpg",
      "/catalog/nemrut-tile.jpg"
    ],
    "description": "Nemrut dağının volkanik ruhu; karanlık ve dramatik.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Antrasit",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "nora",
    "name": "Nora",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Bej",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Rezidans"
    ],
    "image": "/catalog/nora-hero.jpg",
    "hero": "/catalog/nora-hero.jpg",
    "tile": "/catalog/nora-tile.jpg",
    "gallery": [
      "/catalog/nora-hero.jpg",
      "/catalog/nora-tile.jpg"
    ],
    "description": "Zarif damar detayları — rezidans salonlarının rafine dili.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "odeon",
    "name": "Odeon",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Klasik"
    ],
    "image": "/catalog/odeon-hero.jpg",
    "hero": "/catalog/odeon-hero.jpg",
    "tile": "/catalog/odeon-tile.jpg",
    "gallery": [
      "/catalog/odeon-hero.jpg",
      "/catalog/odeon-tile.jpg"
    ],
    "description": "Antik Odeon amfitiyatrolarının anıtsal ölçeğinden esinlenmiş klasik beyaz.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "parma",
    "name": "Parma",
    "category": "porselen",
    "finish": "Mat",
    "color": "Krem",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Krem",
      "Rezidans"
    ],
    "image": "/catalog/parma-hero.jpg",
    "hero": "/catalog/parma-hero.jpg",
    "tile": "/catalog/parma-tile.jpg",
    "gallery": [
      "/catalog/parma-hero.jpg",
      "/catalog/parma-tile.jpg"
    ],
    "description": "Sıcak krem tonlarında huzurlu ve yalın bir yüzey.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Krem",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "patara",
    "name": "Patara",
    "category": "dis-mekan",
    "finish": "Mat",
    "color": "Sarı Kum",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Kum",
      "Butik"
    ],
    "image": "/catalog/patara-hero.jpg",
    "hero": "/catalog/patara-hero.jpg",
    "tile": "/catalog/patara-tile.jpg",
    "gallery": [
      "/catalog/patara-hero.jpg",
      "/catalog/patara-tile.jpg"
    ],
    "description": "Antik Patara plajından ilham; sarı-kum tonlarında bir sıcaklık.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Sarı Kum",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "perla",
    "name": "Perla",
    "category": "banyo",
    "finish": "Parlak",
    "color": "İnci Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Butik"
    ],
    "image": "/catalog/perla-hero.jpg",
    "hero": "/catalog/perla-hero.jpg",
    "tile": "/catalog/perla-tile.jpg",
    "gallery": [
      "/catalog/perla-hero.jpg",
      "/catalog/perla-tile.jpg"
    ],
    "description": "İnci yüzeyinin optik parlaklığı — butik banyolar için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "İnci Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "portoro",
    "name": "Portoro",
    "category": "granit",
    "finish": "Parlak",
    "color": "Siyah Altın",
    "sizes": [
      "60x120 cm",
      "80x160 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Siyah",
      "Altın",
      "Butik"
    ],
    "image": "/catalog/portoro-hero.jpg",
    "hero": "/catalog/portoro-hero.jpg",
    "tile": "/catalog/portoro-tile.jpg",
    "gallery": [
      "/catalog/portoro-hero.jpg",
      "/catalog/portoro-tile.jpg"
    ],
    "description": "Siyah zemin üzerine zarif altın detaylar — butik mekânlarda göz alıcı bir seçim.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Siyah Altın",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "pulpis",
    "name": "Pulpis",
    "category": "porselen",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Salon"
    ],
    "image": "/catalog/pulpis-hero.jpg",
    "hero": "/catalog/pulpis-hero.jpg",
    "tile": "/catalog/pulpis-tile.jpg",
    "gallery": [
      "/catalog/pulpis-hero.jpg",
      "/catalog/pulpis-tile.jpg"
    ],
    "description": "Pulpis koleksiyonunun ince damar hareketleriyle zarif bir porselen yorumu.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "rapsodi",
    "name": "Rapsodi",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Gri Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Gri",
      "Modern"
    ],
    "image": "/catalog/rapsodi-hero.jpg",
    "hero": "/catalog/rapsodi-hero.jpg",
    "tile": "/catalog/rapsodi-tile.jpg",
    "gallery": [
      "/catalog/rapsodi-hero.jpg",
      "/catalog/rapsodi-tile.jpg"
    ],
    "description": "Gri ve beyazın uyumlu senfonisi — modern mekânlara aydınlık bir dokunuş.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Gri Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "sardes",
    "name": "Sardes",
    "category": "porselen",
    "finish": "Mat",
    "color": "Antrasit",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Antrasit",
      "Modern"
    ],
    "image": "/catalog/sardes-hero.jpg",
    "hero": "/catalog/sardes-hero.jpg",
    "tile": "/catalog/sardes-tile.jpg",
    "gallery": [
      "/catalog/sardes-hero.jpg",
      "/catalog/sardes-tile.jpg"
    ],
    "description": "Antik Sardes uygarlığından ilhamla karakterli bir antrasit.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Antrasit",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "sare",
    "name": "Sare",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Bej",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Rezidans"
    ],
    "image": "/catalog/sare-hero.jpg",
    "hero": "/catalog/sare-hero.jpg",
    "tile": "/catalog/sare-tile.jpg",
    "gallery": [
      "/catalog/sare-hero.jpg",
      "/catalog/sare-tile.jpg"
    ],
    "description": "Sarı-bej tonlarında sakin bir yüzey — rezidansların dili.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "savona",
    "name": "Savona",
    "category": "porselen",
    "finish": "Mat",
    "color": "Krem",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Krem",
      "Minimal"
    ],
    "image": "/catalog/savona-hero.jpg",
    "hero": "/catalog/savona-hero.jpg",
    "tile": "/catalog/savona-tile.jpg",
    "gallery": [
      "/catalog/savona-hero.jpg",
      "/catalog/savona-tile.jpg"
    ],
    "description": "Sıcak krem tonlarında Akdeniz esintili mat bir yüzey.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Krem",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "serena",
    "name": "Serena",
    "category": "mutfak",
    "finish": "Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm",
      "80x160 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Salon"
    ],
    "image": "/catalog/serena-hero.jpg",
    "hero": "/catalog/serena-hero.jpg",
    "tile": "/catalog/serena-tile.jpg",
    "gallery": [
      "/catalog/serena-hero.jpg",
      "/catalog/serena-tile.jpg"
    ],
    "description": "Sakinliğin adını taşıyan parlak beyaz — sonsuz bir dinginlik.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm / 80x160 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "terra",
    "name": "Terra",
    "category": "porselen",
    "finish": "Mat",
    "color": "Terracotta",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Terracotta",
      "Rustik"
    ],
    "image": "/catalog/terra-hero.jpg",
    "hero": "/catalog/terra-hero.jpg",
    "tile": "/catalog/terra-tile.jpg",
    "gallery": [
      "/catalog/terra-hero.jpg",
      "/catalog/terra-tile.jpg"
    ],
    "description": "Toprağın sıcaklığı — Akdeniz mimarisinin çağdaş yorumu.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Terracotta",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "titan",
    "name": "Titan",
    "category": "granit",
    "finish": "Mat",
    "color": "Duman",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Duman",
      "Modern"
    ],
    "image": "/catalog/titan-hero.jpg",
    "hero": "/catalog/titan-hero.jpg",
    "tile": "/catalog/titan-tile.jpg",
    "gallery": [
      "/catalog/titan-hero.jpg",
      "/catalog/titan-tile.jpg"
    ],
    "description": "Titanyum yüzeyin mineral parlaklığından ilham — modern ve güçlü.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Duman",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "tortuga",
    "name": "Tortuga",
    "category": "dis-mekan",
    "finish": "Mat",
    "color": "Terracotta",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Terracotta",
      "Rustik"
    ],
    "image": "/catalog/tortuga-hero.jpg",
    "hero": "/catalog/tortuga-hero.jpg",
    "tile": "/catalog/tortuga-tile.jpg",
    "gallery": [
      "/catalog/tortuga-hero.jpg",
      "/catalog/tortuga-tile.jpg"
    ],
    "description": "Kaplumbağa kabuğu dokusundan esinlenmiş organik bir yüzey.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Terracotta",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "tosca",
    "name": "Tosca",
    "category": "mutfak",
    "finish": "Yarı Parlak",
    "color": "Bej",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Salon"
    ],
    "image": "/catalog/tosca-hero.jpg",
    "hero": "/catalog/tosca-hero.jpg",
    "tile": "/catalog/tosca-tile.jpg",
    "gallery": [
      "/catalog/tosca-hero.jpg",
      "/catalog/tosca-tile.jpg"
    ],
    "description": "Toskana esintili sıcak bir bej; klasik mimari için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "tropikal",
    "name": "Tropikal",
    "category": "porselen",
    "finish": "Mat",
    "color": "Ahşap Bej",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Ahşap",
      "Salon"
    ],
    "image": "/catalog/tropikal-hero.jpg",
    "hero": "/catalog/tropikal-hero.jpg",
    "tile": "/catalog/tropikal-tile.jpg",
    "gallery": [
      "/catalog/tropikal-hero.jpg",
      "/catalog/tropikal-tile.jpg"
    ],
    "description": "Tropik ahşap dokusunun porselen dayanıklılığıyla buluştuğu koleksiyon.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Ahşap Bej",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "tuval",
    "name": "Tuval",
    "category": "banyo",
    "finish": "Mat",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Minimal"
    ],
    "image": "/catalog/tuval-hero.jpg",
    "hero": "/catalog/tuval-hero.jpg",
    "tile": "/catalog/tuval-tile.jpg",
    "gallery": [
      "/catalog/tuval-hero.jpg",
      "/catalog/tuval-tile.jpg"
    ],
    "description": "Bir sanatçının boş tuvali gibi — saf, sınırsız, saygılı.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "urla",
    "name": "Urla",
    "category": "dis-mekan",
    "finish": "Mat",
    "color": "Doğal Taş",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Bej",
      "Sahil"
    ],
    "image": "/catalog/urla-hero.jpg",
    "hero": "/catalog/urla-hero.jpg",
    "tile": "/catalog/urla-tile.jpg",
    "gallery": [
      "/catalog/urla-hero.jpg",
      "/catalog/urla-tile.jpg"
    ],
    "description": "Ege sahillerinin doğal taş yüzeyi — Urla, evinizin sakin köşesi.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Doğal Taş",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "vela",
    "name": "Vela",
    "category": "porselen",
    "finish": "Yarı Parlak",
    "color": "Beyaz",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Beyaz",
      "Marina"
    ],
    "image": "/catalog/vela-hero.jpg",
    "hero": "/catalog/vela-hero.jpg",
    "tile": "/catalog/vela-tile.jpg",
    "gallery": [
      "/catalog/vela-hero.jpg",
      "/catalog/vela-tile.jpg"
    ],
    "description": "Yat yelkenlerinin beyazlığından ilham — marina rezidansları için.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Yarı Parlak",
      "Renk": "Beyaz",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "vira",
    "name": "Vira",
    "category": "granit",
    "finish": "Mat",
    "color": "Antrasit",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Antrasit",
      "Ofis"
    ],
    "image": "/catalog/vira-hero.jpg",
    "hero": "/catalog/vira-hero.jpg",
    "tile": "/catalog/vira-tile.jpg",
    "gallery": [
      "/catalog/vira-hero.jpg",
      "/catalog/vira-tile.jpg"
    ],
    "description": "Denizciliğin 'vira' komutundan ilham — güçlü, kararlı, modern.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Antrasit",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "woodline",
    "name": "Woodline",
    "category": "porselen",
    "finish": "Mat",
    "color": "Meşe",
    "sizes": [
      "20x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Ahşap",
      "Salon"
    ],
    "image": "/catalog/woodline-hero.jpg",
    "hero": "/catalog/woodline-hero.jpg",
    "tile": "/catalog/woodline-tile.jpg",
    "gallery": [
      "/catalog/woodline-hero.jpg",
      "/catalog/woodline-tile.jpg"
    ],
    "description": "Meşe ahşabının sıcak dokusu porselen dayanıklılığıyla — Woodline.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "20x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Meşe",
      "V Sınıfı": "V3"
    }
  },
  {
    "slug": "zen",
    "name": "Zen",
    "category": "banyo",
    "finish": "Mat",
    "color": "Doğal Kum",
    "sizes": [
      "60x120 cm"
    ],
    "thickness": "0.9 cm",
    "v_class": "V3",
    "surface": "Sırlı Porselen",
    "tags": [
      "Kum",
      "Spa"
    ],
    "image": "/catalog/zen-hero.jpg",
    "hero": "/catalog/zen-hero.jpg",
    "tile": "/catalog/zen-tile.jpg",
    "gallery": [
      "/catalog/zen-hero.jpg",
      "/catalog/zen-tile.jpg"
    ],
    "description": "Zen bahçelerinin dinginliği — wellness ve spa alanları için tasarlandı.",
    "tech": {
      "Ürün Cinsi": "Sırlı Porselen",
      "Ebat": "60x120 cm",
      "Kalınlık": "0.9 cm",
      "Yüzey": "Mat",
      "Renk": "Doğal Kum",
      "V Sınıfı": "V3"
    }
  }
];
